import { useEffect, useState } from "react";

export const TICK_MS = 1000;

// One interval for the whole page, not one per row. OrderListingComponent is
// rendered once per order, so a hook that owned its own setInterval would run
// 20 timers on a 20-row listing and wake them at 20 different moments.
const subscribers = new Set();
let timer = null;

const notify = () => {
  const now = Date.now();
  subscribers.forEach((fn) => fn(now));
};

export const subscribeToClock = (fn) => {
  subscribers.add(fn);
  if (timer === null) {
    timer = setInterval(notify, TICK_MS);
  }
  return () => {
    subscribers.delete(fn);
    // Nothing on screen needs the clock any more; leaving it running would keep
    // waking a backgrounded tab for no reason.
    if (subscribers.size === 0 && timer !== null) {
      clearInterval(timer);
      timer = null;
    }
  };
};

export const clockSubscriberCount = () => subscribers.size;
export const clockIsRunning = () => timer !== null;

/** Milliseconds, refreshed every TICK_MS, shared across every caller. */
export const useNow = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => subscribeToClock(setNow), []);
  return now;
};
